module.exports = __webpack_public_path__ + "static/the-decadent-society-249b3b854184811531cbe83da9c048b2.jpg";